<script setup lang="ts">
import { useRouter } from 'vue-router';

const router = useRouter();

function startNewSale() {
  router.push({ name: 'CustomerSelect' });
}
</script>

<template>
  <div class="sales-step bg-white">
    <div class="h-full flex flex-col items-center justify-center p-8">
      <div class="mb-6 text-success-500">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-20 w-20 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </div>
      
      <h1 class="text-2xl font-bold text-neutral-900 mb-2 text-center">Order Complete!</h1>
      <p class="text-neutral-600 text-center mb-8">Your sale has been successfully processed.</p>
      
      <div class="animate-scale-in">
        <div class="card text-center bg-primary-50 border border-primary-200 mb-8">
          <p class="text-neutral-900 font-medium">Order ID: #{{ Math.floor(Math.random() * 10000).toString().padStart(4, '0') }}</p>
          <p class="text-sm text-neutral-600">{{ new Date().toLocaleString() }}</p>
        </div>
      </div>
      
      <button @click="startNewSale" class="btn btn-primary w-full">
        Start New Sale
      </button>
    </div>
  </div>
</template>